import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

// Connects to data-controller="hold-timer"
//
// Derives the remaining time from a monotonic deadline instead of decrementing a counter, so a
// throttled background tab that skips ticks still shows the true remaining time when it resumes.
// The deadline is anchored to the server-computed remaining seconds rather than to a wall-clock
// timestamp, so a skewed device clock cannot expire a hold that is still valid.
export default class extends Controller {
  static targets = ["remaining"]
  static values = { remainingSeconds: Number, expiredUrl: String }

  connect() {
    const storedDeadline = Number(this.element.dataset.holdTimerDeadline)
    this.deadline = Number.isFinite(storedDeadline) && storedDeadline > 0
      ? storedDeadline
      : this.now() + this.remainingSecondsValue * 1000
    this.element.dataset.holdTimerDeadline = String(this.deadline)
    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  now() {
    return typeof performance !== "undefined" && performance.now ? performance.now() : Date.now()
  }

  remainingSeconds() {
    return Math.max(0, Math.ceil((this.deadline - this.now()) / 1000))
  }

  render() {
    const remaining = this.remainingSeconds()
    const minutes = Math.floor(remaining / 60)
    const seconds = remaining % 60
    this.remainingTarget.textContent = `${minutes}:${String(seconds).padStart(2, "0")}`

    if (remaining <= 0) {
      clearInterval(this.timer)
      visit(this.expiredUrlValue)
    }
  }
}
